import axios from 'axios'
export default () => {
  return axios.create({
    // This is local addresses at the dir z-laravel
    // baseURL: 'http://192.168.1.103:8000/api'

    // This is hosting address
     baseURL: 'http://server.zillja.info/api'

  })



}
